import React, { FC, useEffect, useState } from 'react';

import cn from 'classnames';
import numbers from 'utils/numbers';

// import Chevron from "@Svg/Chevron";
import Chevron from 'ui/Chevron';
import Mask from 'ui/Phone/components/Mask';
import Flag from 'ui/Phone/components/Flag';
import Country from 'ui/Phone/components/Country';

import maskHandler from 'ui/Phone/functions/mask.handler';
import getCountryQuery from 'ui/Phone/functions/getCountryQuery';

import service from 'error-handler/functions/service';

import { CountryPhone, IPhone, IPhoneNumber, PhoneType } from 'ui/Phone/types';
import { defaultNumber } from 'ui/Phone/constants';
import Select, { PanelSlot } from 'ui/Phone/components/Select';
// import useSelect from "@Hook/useSelect";
import useSelect from 'utils/hooks/useSelect';

const Phone: FC<IPhone> = ({
  label,
  error,
  setFormData,
  name,
  setErrors,
  value,
  callback,
  setCountryCode,
  selectClassNames,
}): React.ReactElement => {
  const [inputValue, setInputValue] = useState<string>('');
  const [activeEl, setActiveEl] = useState<PhoneType>(defaultNumber);

  const [phone, setPhone] = useState<string>('');
  const [fill, setFill] = useState<boolean>(false);

  const { openSelect, setOpenSelect, closeSelect } = useSelect();

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    (async () => {
      const { number, mask }: CountryPhone = await getCountryQuery();
      setActiveEl(number);
      callback(mask);
    })();
  }, []);

  useEffect(() => {
    setCountryCode && setCountryCode(activeEl.countryCode);
  }, [activeEl]);

  useEffect(() => {
    !value && setFormData((state: any) => ({ ...state, [name]: { iso: activeEl.iso, phone } }));
    setErrors((state: any) => ({ ...state, [name]: '' }));
  }, [phone, activeEl]);

  useEffect(() => {
    value && setFormData((state: any) => ({ ...state, [name]: { iso: '', phone: value } }));
  }, [value]);

  const isoChangeHandler = (props: IPhoneNumber): void => {
    const { iso, countryCode, mask }: IPhoneNumber = props;
    callback(mask);
    setInputValue('');

    setActiveEl({ iso, countryCode, mask });
    setOpenSelect(false);
  };

  const phoneChangeHandler = (e: any): void => {
    if (!value) {
      e.target.value = maskHandler({
        mask: activeEl.mask,
        value: e.target.value,
        validation: (value: boolean): void => {
          if (value) setFill(true);
          else fill && setFill(false);
        },
      });
    }
    setPhone(e.target.value);
    setInputValue(e.target.value);
    closeSelect();
  };

  return (
    <Select<IPhoneNumber>
      label={label}
      error={error}
      name={name}
      panelClassName="select__panel--phone"
      onChange={(state: boolean) => setOpenSelect(state)}
      data={numbers}
      classNames={selectClassNames}
      RenderItem={({ name, iso, countryCode, mask }: IPhoneNumber) => (
        <Country
          key={countryCode}
          iso={iso}
          name={name}
          mask={mask}
          activeISO={activeEl.iso}
          isoChangeHandler={isoChangeHandler}
          countryCode={countryCode}
        />
      )}
      state={openSelect}
      disabledDefaultOnClick
    >
      <PanelSlot>
        {!value && (
          <div onClick={() => setOpenSelect(!openSelect)} className="select__phone">
            <Flag code={activeEl.countryCode.toLowerCase()} />
            <span className={cn('select__panel-number', { 'select__panel-number--fill': fill })}>{activeEl?.iso}</span>

            <Chevron open={openSelect} />
          </div>
        )}

        <div className="select__phone-wrapper">
          <Mask value={inputValue} mask={activeEl.mask.replace(/#/g, '0')} />

          <input
            onChange={(e: any) => service(e)('phoneChangeHandler')(phoneChangeHandler)}
            className={cn('select__input', 'select__input--phone')}
            readOnly={!!value}
            autoComplete="off"
            value={inputValue}
            id={name}
            type="text"
          />
        </div>

        {error ? <div className="input__error">{error}</div> : <></>}
      </PanelSlot>
    </Select>
  );
};

export default Phone;
